var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#ECECEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_5868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 15.8334H26V18.5H34V15.8334ZM28.6667 33.1667H31.3333V25.1667H28.6667V33.1667ZM39.3733 24.3534L41.2667 22.46C40.6933 21.78 40.0667 21.14 39.3867 20.58L37.4933 22.4734C35.4267 20.82 32.8267 19.8334 30 19.8334C23.3733 19.8334 18 25.2067 18 31.8334C18 38.46 23.36 43.8334 30 43.8334C36.64 43.8334 42 38.46 42 31.8334C42 29.0067 41.0133 26.4067 39.3733 24.3534ZM30 41.1667C24.84 41.1667 20.6667 36.9934 20.6667 31.8334C20.6667 26.6734 24.84 22.5 30 22.5C35.16 22.5 39.3333 26.6734 39.3333 31.8334C39.3333 36.9934 35.16 41.1667 30 41.1667Z",
    fill: "#6D6E71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_5868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.977e19ce90addd2f4b76289a9428acd7.svg";
export { ForwardRef as ReactComponent };